import { render, staticRenderFns } from "./conference_type.vue?vue&type=template&id=5ab494f2&scoped=true&"
import script from "./conference_type.vue?vue&type=script&lang=js&"
export * from "./conference_type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab494f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ab494f2')) {
      api.createRecord('5ab494f2', component.options)
    } else {
      api.reload('5ab494f2', component.options)
    }
    module.hot.accept("./conference_type.vue?vue&type=template&id=5ab494f2&scoped=true&", function () {
      api.rerender('5ab494f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/conference/conference_type/conference_type.vue"
export default component.exports